// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.verification

import org.multipaz.cbor.DataItem
import org.multipaz.verification.PresentmentRecord
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.verification.Iso18013PresentmentRecord
import org.multipaz.verification.OpenID4VPPresentmentRecord

fun PresentmentRecord.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "tHnOA6j3kzWMVm_3ObEkVf-wnCo-X4kyjVCIljvsL6E")
val PresentmentRecord_cborSchemaId = ByteString(-76, 121, -50, 3, -88, -9, -109, 53, -116, 86, 111, -9, 57, -79, 36, 85, -1, -80, -100, 42, 62, 95, -119, 50, -115, 80, -120, -106, 59, -20, 47, -95)

fun PresentmentRecord.Companion.fromCbor(data: ByteArray): PresentmentRecord {
    return PresentmentRecord.fromDataItem(Cbor.decode(data))
}

val PresentmentRecord.Companion.cborSchemaId: ByteString
    get() = PresentmentRecord_cborSchemaId

fun PresentmentRecord.toDataItem(): DataItem {
    return when (this) {
        is Iso18013PresentmentRecord -> (this as Iso18013PresentmentRecord).toDataItem()
        is OpenID4VPPresentmentRecord -> (this as OpenID4VPPresentmentRecord).toDataItem()
    }
}

fun PresentmentRecord.Companion.fromDataItem(dataItem: DataItem): PresentmentRecord {
    val type = dataItem["type"].asTstr
    return when (type) {
        "Iso18013" -> Iso18013PresentmentRecord.fromDataItem(dataItem)
        "OpenID4VP" -> OpenID4VPPresentmentRecord.fromDataItem(dataItem)
        else -> throw IllegalArgumentException("wrong type: $type")
    }
}
